module.exports = __webpack_public_path__ + "static/media/GloBritme-3.afef8f6a.png";